<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import CustomerAsyncSelect from "./_modules/customer-async-select"
  import type {
    AddressFilterValue,
    FilterDisplayMode,
  } from "../../_shared/_logic/address-table-contract"

  const archiveScopeOptions = [
    { name: "Aktiv", value: "ACTIVE" },
    { name: "Archiviert", value: "ARCHIVED" },
    { name: "Alle", value: "ALL" },
  ]

  let {
    filters = $bindable(),
    filterMode,
    organizationId,
    customers = [],
    importLocked = false,
    onChange = () => {},
  }: {
    filters: AddressFilterValue
    filterMode: FilterDisplayMode
    organizationId: string
    customers?: Customer[]
    importLocked?: boolean
    onChange?: () => void
  } = $props()
</script>

<div class="filter-bar form">
  <Input
    type="text"
    placeholder="Suche (z. B. Musterstr 12 20095)"
    bind:value={filters.search}
    brightBackground={true}
    disabled={importLocked}
    tooltip="Volltextsuche über Liegenschaft, Ansprechpartner und Einheiten. Mehrere Begriffe inkl. Zahlen werden kombiniert (z. B. Straße + Hausnr. + PLZ)."
    {onChange}
  />
  {#if filterMode === "detailed"}
    <CustomerAsyncSelect
      id="address-filter-customer"
      {organizationId}
      seedCustomers={customers}
      placeholder="Ansprechpartner auswählen"
      bind:value={filters.customerId}
      brightBackground={true}
      disabled={importLocked}
      {onChange}
    />
    <Input
      type="number"
      placeholder="Anzahl Einheiten"
      bind:value={filters.unitCount}
      brightBackground={true}
      disabled={importLocked}
      tooltip="Filtert nach exakter Anzahl der Einheiten."
      {onChange}
    />
    <Input
      type="number"
      placeholder="Anzahl Ansprechpartner"
      bind:value={filters.contactCount}
      brightBackground={true}
      disabled={importLocked}
      tooltip="Filtert nach exakter Anzahl der Ansprechpartner."
      {onChange}
    />
    <Input
      type="text"
      placeholder="Einheit"
      bind:value={filters.unitQuery}
      brightBackground={true}
      disabled={importLocked}
      tooltip="Sucht gezielt in Einheitenname/-nummer."
      {onChange}
    />
    <Input
      type="select"
      placeholder="Archivstatus"
      bind:value={filters.archiveScope}
      options={archiveScopeOptions}
      brightBackground={true}
      disabled={importLocked}
      tooltip="Zeigt aktive, archivierte oder alle Liegenschaften."
      {onChange}
    />
  {/if}
</div>

<style lang="less">
  .filter-bar {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 0.65rem;
    align-items: end;
    margin: 0 0 1rem 0;

    :global(.input),
    :global(.select-input) {
      width: 100%;
    }
  }
</style>
